import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { SqliteStorageService } from '../services/sqlite-storage/sqlite-storage.service';
import { DriverResponse } from '../models/driver.model';

export const dashboardResolver: ResolveFn<boolean> = async (route, state) => {
  const dashboardService = inject(DashboardService);
  const sqliteStorageService = inject(SqliteStorageService);
  const router = inject(Router);

  if (navigator.onLine) {
    await dashboardService.processMeData();
  }

  // Then check personal-use declaration
  try {
    const meData = await sqliteStorageService.getItem<DriverResponse>('meData');
    const hasPersonalUsePermission = meData?.menus?.some(
      (menu) => menu.title == 'FeaturePersonalUseDeclaration'
    );

    if (hasPersonalUsePermission && meData && meData.vehicles && meData.vehicles.length > 0) {
      const hasPersonalUseDeclarationNeeded = meData.vehicles.some(
        (vehicle) => vehicle.personaL_USE === false
      );

      if (navigator.onLine && hasPersonalUseDeclarationNeeded) {
        router.navigateByUrl('/personal-use-declaration');
        return false;
      }
    }
  } catch (error) {
    console.error('Error checking personal use status:', error);
  }

  return true;
};
